<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <VenueInfoForm ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></VenueInfoForm>
  </j-modal>
</template>

<script>

  import VenueInfoForm from './VenueInfoForm.vue';
  
  export default {
    name: 'VenueInfoModal',
    components: {
      VenueInfoForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        parent:{},
      }
    },
    methods: {
      refreshTree()
      {
        this.$emit('refreshTree');
      },
      add () {
        var that =this;
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.model.sysvenueid=that.parent.sysvenueid;
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(venueInfo){
        this.$emit('ok',venueInfo);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>